import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { Observable } from "rxjs";
import { HttpClient, HttpResponse } from "@angular/common/http";
import { Cop } from "../../shared/models/cop";
import { User } from "../../shared/models";
import { UserCopBusinessUnit } from "../../shared/models/user-trigger-business-unit";

@Injectable({
  providedIn: "root",
})
export class UserCopBusinessUnitService {
  constructor(private http: HttpClient) {}

  apiRoot = `${environment.apiUrl}UserCopBusinessUnit`;

  public getAllUsersByCopId(copId: number): Observable<User[]> {
    return this.http.get<User[]>(`${this.apiRoot}/getAllUsersByCopId/${copId}`);
  }

  public getAllUsersByBusinessUnit(businessUnit: string): Observable<User[]> {
    return this.http.get<User[]>(
      `${this.apiRoot}/getAllUsersByBusinessUnit/${businessUnit}`
    );
  }

  public getAllUsersByBuId(buId: number): Observable<User[]> {
    return this.http.get<User[]>(
      `${this.apiRoot}/getAllUsersByBusinessUnitId/${buId}`
    );
  }

  public getAllCopApprovers(userId: number): Observable<Cop[]> {
    return this.http.get<Cop[]>(`${this.apiRoot}/getAllCopApprovers/${userId}`);
  }

  public getAllCopApproversByUserIdAndBusinessUnitId(
    userId: number,
    businessUnitId: number
  ): Observable<Cop[]> {
    return this.http.get<Cop[]>(
      `${this.apiRoot}/getAllCopApproversByUserIdAndBusinessUnitId/${userId}/${businessUnitId}`
    );
  }

  public getAllCopApproversByUniqueKey(uniqueKey: string): Observable<Cop[]> {
    return this.http.get<Cop[]>(
      `${this.apiRoot}/getAllCopApproversByUniqueKey/${uniqueKey}`
    );
  }

  public getAllUsers(id: number): Observable<User[]> {
    return this.http.get<User[]>(`${this.apiRoot}/getAllUsersByTeamId/${id}`);
  }

  public createUserCopBusinessUnit(
    triggerCode: string,
    uniqueKey: string,
    businessUnitCode: string
  ): Observable<HttpResponse<UserCopBusinessUnit>> {
    const endPoint = `${this.apiRoot}/createUserCopBusinessUnitV2`;
    const body = { triggerCode, uniqueKey, businessUnitCode };
    return this.http.post<UserCopBusinessUnit>(endPoint, body, {
      observe: "response",
    });
  }

  public deleteUserCopBusinessUnit(
    uniqueKey: string,
    cop: string,
    businessUnit: string
  ) {
    const endPoint = `${this.apiRoot}/deleteUserCopBusinessUnit/uniqueKey=${uniqueKey}/cop=${cop}/businessUnit=${businessUnit}`;
    return this.http.delete(endPoint);
  }
}
